export default "__VITE_ASSET__Mgm1G$IL__";